import React from 'react';
import Hero from '../components/site/Hero';
import AboutStrip from '../components/site/AboutStrip';
import ProjectsShowcase from '../components/site/ProjectsShowcase';
import VideoPayment from '../components/site/VideoPayment';
import Nearby from '../components/site/Nearby';
import Memorial from '../components/site/Memorial';
import { Testimonials, BlogPreview, CtaBanner } from '../components/site/BottomSections';
import HomeRecentPosts from '../components/site/HomeRecentPosts';


export default function Home() {
  return (
    <div>
      <Hero />
      <AboutStrip />
      {/* <ProjectsShowcase /> */}
      <Nearby />
      <VideoPayment />
      <Memorial />
      <Testimonials />
      {/* <HomeRecentPosts /> */}
      <BlogPreview />
      <CtaBanner />
    </div>
  );
}
